import { SET_CAMPAIGN_TAB } from '../../action-types';
import createAction from '../../create-action';

export const setCampaignTab = createAction(SET_CAMPAIGN_TAB);
